export default {"src":"/_next/static/media/view.cd253c25.svg","height":20,"width":20};